import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Signaltag } from '../../../models/trend-live-models/OPTag';
import { FormGroup, FormBuilder, FormArray, Form } from '@angular/forms';
// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { SPINNER_CONFIG } from 'src/app/shared/spinner-config';
import { AdvancedFilters, AdvancedFiltersItem } from './AdvancedFilters';

interface FilterConfig {
  tags: Signaltag[];
  advancedFilters: AdvancedFilters<Signaltag>,
  query: string;
  filters: any;
}

@Component({
  selector: 'app-tags-filter',
  templateUrl: './tags-filter.component.html'
})
export class TagsFilterComponent implements OnInit, OnDestroy {

  tags: Signaltag[] = [];
  filteredTags: Signaltag[] = [];

  _filters: any;
  _tagsQuery: string;
  _advancedFilters: AdvancedFilters<Signaltag>;
  _filterConfigChanges = new BehaviorSubject<FilterConfig>
    (undefined);
  inputChangesSub: Subscription;
  @Input() set filterConfig(value: FilterConfig) {
    if (value !== undefined && value !== null) {
      this._filterConfigChanges.next(value);
    }
  }

  filtersFormSub: Subscription;
  filtersForm: FormGroup;

  // spinnerConfig = SPINNER_CONFIG;
  filtersLoading = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.filtersForm = this.fb.group({
      filters: this.fb.array([])
    });
    this.filtersFormSub = this.filtersForm.valueChanges.subscribe(() => {
      this.filtersLoading = true;
      this.applyFiltersPreview();
    });
    this.watchFilterInputChnages();
  }

  watchFilterInputChnages() {
    this.inputChangesSub = this._filterConfigChanges.subscribe(value => {
      this.tags = value.tags;
      this.filteredTags = this.tags.slice();
      this._advancedFilters = value.advancedFilters;
      this._tagsQuery = value.query;
      this._filters = value.filters;
      this.buildForm();
    });
  }

  private buildForm() {
    for (const filter of this._advancedFilters.filterItems) {
      const optionsSet = new Set<string>();
      for (const tag of this.tags) {
        optionsSet.add(filter.extractProperty(tag));
      }
      this.addFormItem(filter, Array.from(optionsSet).filter(x => (x !== null && x !== undefined && x.replace(/\s+/g, '') !== '')));
    }

    if (this._filters) {
      this.filtersForm.setValue(this._filters);
    }
  }

  private addFormItem(filter: AdvancedFiltersItem<Signaltag>, options: any) {
    const filtersFormControl = this.filtersForm.get('filters') as FormArray;
    filtersFormControl.push(this.fb.group({
      filterName: filter.filterName,
      options: this.fb.array(this.addFormItemOptions(options))
    }));
  }

  private addFormItemOptions(options: any[]) {
    return options.map(entry => this.fb.group({
      filterOptionName: entry,
      value: false
    }));
  }

  applyFilters() {
    // this.activeModal.close({
    //   query: this._tagsQuery,
    //   filters: this.filtersForm.value
    // });
  }

  applyFiltersPreview() {
    try {
      this.filterTags();

    } catch (error) {
      console.log(error);
      // do nothing
    }
    this.filtersLoading = false;
  }


  queryChanged(query: string) {
    this._tagsQuery = query;
    this.filterTags();
  }

  /**
   * Apply current filters including the searchbox query
   */
  filterTags() {
    console.log('tags length', this.tags.length);
    this.filteredTags = this.tags.slice();
    if (this._tagsQuery) {

      const result = this.filteredTags
        .filter(v => v.tagName.toLowerCase()
          .indexOf(this._tagsQuery.toLowerCase()) > -1 || v.tagDescription
            .toLowerCase().indexOf(this._tagsQuery.toLowerCase()) > -1);

      this.filteredTags = result;
      console.log('filtered tags length', this._tagsQuery);
    }


    const filtersValue = (this.filtersForm.value['filters']).slice();
    const activeFilters = filtersValue.map(entry => {
      const newEntry = Object.assign({}, entry);
      newEntry.options = entry.options.filter(opEntry => opEntry.value === true).map(x => x.filterOptionName);
      return newEntry;
    }).filter(entry => entry.options.length);
    if (activeFilters.length) {
      this.filteredTags = this.filteredTags.filter(tag => {
        let keepTag = true;
        for (const item of activeFilters) {
          if (item.options.indexOf(tag[item.filterName]) < 0) {
            keepTag = false;
          }
        }
        return keepTag;
      });
    }

  }

  close() {
    // this.activeModal.close();
  }

  ngOnDestroy() {
    if (this.filtersFormSub) {
      this.filtersFormSub.unsubscribe();
    }

    if (this.inputChangesSub) {
      this.inputChangesSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/trend-explorer/tags-filter/tags-filter.component.ts